import loadable from '@loadable/component';

export const ViewUserProfilePageLoadable = loadable(
  () => import('./ViewUserProfilePagePublicProfile'),
  { resolveComponent: (module) => module.ViewUserProfilePagePublicProfile },
);
